import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { ProductCert } from '@/api/product';
import { humanFileSize } from '@/api/formatSize';

const EXEMPT_FALLBACK = 'не требует обязательной сертификации и декларирования';

// Запасной вариант для браузеров без Clipboard API (и не-https окружений).
function legacyCopy(text: string) {
    const textarea = document.createElement('textarea');
    textarea.value = text;
    textarea.setAttribute('readonly', '');
    textarea.style.position = 'fixed';
    textarea.style.opacity = '0';
    document.body.appendChild(textarea);
    textarea.select();
    document.execCommand('copy');
    document.body.removeChild(textarea);
}

@Component
export default class ProductDocuments extends Vue {
    @Prop({ required: true }) cert!: ProductCert;

    copied = false
    // v-model тултипа копирования: открывается и по наведению, и после копирования
    copyTooltip = false
    copiedTimer = 0

    get fileSize() {
        return typeof this.cert.size === 'number' && this.cert.size > 0
            ? humanFileSize(this.cert.size)
            : ''
    }

    get downloadLabel() {
        return this.fileSize
            ? 'Скачать сертификат соответствия, ' + this.fileSize
            : 'Скачать сертификат соответствия'
    }

    get accreditationUrl() {
        return this.cert.accreditationUrl || ''
    }

    get exemptLabel() {
        return this.cert.exemptLabel || EXEMPT_FALLBACK
    }

    // Карточка реестра не зависит от PDF: либо ссылка, либо пометка «не требует»
    get hasRegistry() {
        return Boolean(this.accreditationUrl || this.cert.exempt)
    }

    get copyLabel() {
        return this.copied ? 'Ссылка скопирована' : 'Скопировать ссылку'
    }

    async copyAccreditationUrl() {
        if (!this.accreditationUrl) return
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(this.accreditationUrl)
            } else {
                legacyCopy(this.accreditationUrl)
            }
            this.copied = true
            this.copyTooltip = true
            window.clearTimeout(this.copiedTimer)
            this.copiedTimer = window.setTimeout(() => {
                this.copied = false
                this.copyTooltip = false
            }, 2000)
        } catch (error) {
            console.log(error)
        }
    }

    beforeDestroy() {
        window.clearTimeout(this.copiedTimer)
    }
}
